module.exports = __webpack_public_path__ + "static/26-HOW-TO-AVOID-EMPLOYEE-TURNOVER-bb98bbda7f237a634fe3a14783d65c29.jpg";